import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { OutputConfigSlice } from "../../redux";
import { useUser } from "../../../../../AuthContext";
import { OutputMappingListView } from "./OutputMappingList.view";
import { FetchOutputConfigMapsList } from "./Scripts";

/**
 *Output Mapping List logic
 */
export const OutputMappingList: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const configId = outputConfig.selectedOutputConfig.id;
  const { user } =  useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  useEffect(() => {
    FetchOutputConfigMapsList(dispatch, translate, configId, env, user?.token);
    return (): void => {
      dispatch(OutputConfigSlice.actions.setOutputMappingList([]));
      dispatch(OutputConfigSlice.actions.setFocusConfigId(""));
    };
  }, []);

  return (
    <OutputMappingListView />
  );
};
